import { render, staticRenderFns } from "./logTable.vue?vue&type=template&id=67097fb1&scoped=true"
import script from "./logTable.vue?vue&type=script&lang=js"
export * from "./logTable.vue?vue&type=script&lang=js"
import style0 from "./logTable.vue?vue&type=style&index=0&id=67097fb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67097fb1",
  null
  
)

export default component.exports